import { ReactElement } from 'react'

import { DocumentsBulkActions } from '../DocumentsBulkActions'
import { DocumentsSearchActions } from '../DocumentsSearchActions'

interface DocumentsActionsBarProps {
  isEmpty: boolean
  isLoading: boolean
  placeholder: string
  searchQuery: string
  selectedIds: string[]
  onDelete?: () => void
  onDownload?: () => void
  onMoveToFolder?: () => void
  onSearchChange: (query: string) => void
}

export const DocumentsActionsBar = ({
  isEmpty,
  isLoading,
  placeholder,
  searchQuery,
  selectedIds,
  onDelete,
  onDownload,
  onMoveToFolder,
  onSearchChange,
}: DocumentsActionsBarProps): ReactElement | null => {
  if (isEmpty || isLoading) {
    return null
  }

  const hasBulkAction = Boolean(onDelete || onDownload || onMoveToFolder)

  return selectedIds.length > 0 && hasBulkAction ? (
    <DocumentsBulkActions onDelete={onDelete} onDownload={onDownload} onMoveToFolder={onMoveToFolder} />
  ) : (
    <DocumentsSearchActions searchQuery={searchQuery} onSearchChange={onSearchChange} placeholder={placeholder} />
  )
}
